module.exports = __webpack_public_path__ + "img/6.77246e91.webp";